export class CryptoService {
  constructor() {
    this.algorithm = 'AES-GCM';
    this.keyLength = 256;
  }

  async generateKey() {
    return await crypto.subtle.generateKey(
      {
        name: this.algorithm,
        length: this.keyLength
      },
      true,
      ['encrypt', 'decrypt']
    );
  }

  async encryptData(data) {
    try {
      const key = await this.generateKey();
      const iv = crypto.getRandomValues(new Uint8Array(12));
      const encodedData = new TextEncoder().encode(JSON.stringify(data));

      const encryptedData = await crypto.subtle.encrypt(
        {
          name: this.algorithm,
          iv
        },
        key,
        encodedData
      );

      const exportedKey = await crypto.subtle.exportKey('raw', key);

      return {
        data: Array.from(new Uint8Array(encryptedData)),
        iv: Array.from(iv),
        key: Array.from(new Uint8Array(exportedKey))
      };
    } catch (error) {
      console.error('Encryption error:', error);
      throw error;
    }
  }

  async decryptData(encryptedData, iv, keyData) {
    try {
      const key = await crypto.subtle.importKey(
        'raw',
        new Uint8Array(keyData),
        this.algorithm,
        true,
        ['decrypt']
      );

      const decrypted = await crypto.subtle.decrypt(
        {
          name: this.algorithm,
          iv: new Uint8Array(iv)
        },
        key,
        new Uint8Array(encryptedData)
      );

      return JSON.parse(new TextDecoder().decode(decrypted));
    } catch (error) {
      console.error('Decryption error:', error);
      throw error;
    }
  }
}

export default new CryptoService();
